/**
 * Pill de status (visual do StatusBadge do Disparo).
 * Cores disponíveis: green, yellow, red, blue, purple, orange, gray.
 * `pulse` adiciona o dot pulsante; `icon` aceita um elemento (ex.: lucide).
 * Estilos em public/css/list/list.css (.sx-pill).
 */
export default function StatusPill({ color = 'gray', pulse = false, icon = null, children }) {
  return (
    <span className={`sx-pill sx-pill--${color}`}>
      {pulse && <span className="sx-pill-dot" />}
      {icon}
      {children}
    </span>
  );
}
